<template>
  <div>
    <com-table ref="table" :columns="columns" :api="api" :defaultParams="defaultParams">
      <template #operation="row">
        <el-button
          type="primary"
          size="mini"
          @click="handleAudit(row.data)"
          v-if="row.data.status === '1'"
          >审核</el-button
        >
        <el-button type="primary" size="mini" @click="handleDetail(row.data)">详情</el-button>
      </template>
      <template #type="row">
        {{ row.data.type === '1' ? '微信' : row.data.type === '2' ? '银行卡' : '' }}
      </template>
      <template #applyTime="row">
        {{ row.data.applyTime | timeFormate }}
      </template>
      <template #handleTime="row">
        <div v-if="row.data.status !== 1 && row.data.handleTime">
          {{ row.data.handleTime | timeFormate }}
        </div>
      </template>
      <template #status="row">
        {{ status[row.data.status] }}
      </template>
    </com-table>
  </div>
</template>

<script>
import { listApi } from '@/api/finance'

export default {
  props: {
    defaultParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      api: listApi,
      status: {
        1: '待审核',
        2: '通过',
        3: '不通过',
        4: '失败'
      },
      columns: [
        {
          label: '合伙人',
          prop: 'realName',
          width: '150'
        },
        {
          label: '钱包余额',
          prop: 'walletSum',
          width: '150'
        },
        {
          label: '提现金额',
          prop: 'sum',
          width: '150'
        },
        {
          label: '提现方式',
          prop: 'type',
          type: 'slot',
          slotName: 'type',
          width: '120'
        },
        {
          label: '提现时间',
          prop: 'applyTime',
          type: 'slot',
          slotName: 'applyTime',
          width: '180'
        },
        {
          label: '审核状态',
          prop: 'status',
          type: 'slot',
          slotName: 'status',
          width: '150'
        },
        {
          label: '流水号',
          prop: 'transactionId',
          width: '150'
        },
        {
          label: '审核时间',
          prop: 'handleTime',
          type: 'slot',
          slotName: 'handleTime',
          width: '180'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation',
          fixed: 'right',
          width: '180'
        }
      ]
    }
  },
  methods: {
    handleDetail(row) {
      const params = {
        type: 'detail',
        row
      }
      this.$emit('audit', params)
    },
    handleAudit(row) {
      const params = {
        type: 'audit',
        row
      }
      this.$emit('audit', params)
    },
    update() {
      this.$refs.table.getList()
    },
    search(val) {
      this.$refs.table.search(val)
    }
  }
}
</script>

<style lang="scss" scoped></style>
